var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.className,attrs:{"type":_vm.inputType,"disabled":_vm.disabled,"tabindex":""},on:{"click":_vm.onClick}},[(_vm.loading)?_c('span',[_c('i',{staticClass:"fa fa-spin fa-spinner"})]):_c('span',[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }